import { useState, useEffect } from 'react';
import { cardapioService } from '../../services';
import { formatCurrency } from '../../utils/format';
import './Cardapio.css';

export default function Cardapio() {
  const [data, setData] = useState(null);
  const [busca, setBusca] = useState('');
  const [categoriaAtiva, setCategoriaAtiva] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cardapioService.listar()
      .then(res => setData(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="loading"><div className="spinner"></div>Carregando cardápio...</div>;
  }

  if (!data) {
    return <div className="loading">Erro ao carregar cardápio.</div>;
  }

  const categorias = data.categorias || [];

  const categoriasFiltradas = categorias
    .map(cat => ({
      ...cat,
      produtos: cat.produtos.filter(p =>
        (!busca || p.nome.toLowerCase().includes(busca.toLowerCase()) || p.descricao?.toLowerCase().includes(busca.toLowerCase())) &&
        (!categoriaAtiva || cat.nome === categoriaAtiva)
      )
    }))
    .filter(cat => cat.produtos.length > 0);

  return (
    <div className="cardapio-page">
      <div className="cardapio-header">
        <h1>📋 Cardápio Digital</h1>
        <p>Confira nossos deliciosos pastéis e faça seu pedido!</p>
      </div>

      {/* Busca */}
      <div className="cardapio-search">
        <input
          type="text"
          placeholder="🔍 Buscar no cardápio..."
          value={busca}
          onChange={e => setBusca(e.target.value)}
        />
      </div>

      {/* Filtro de categorias */}
      <div className="cardapio-filtros">
        <button
          className={`filtro-btn ${!categoriaAtiva ? 'active' : ''}`}
          onClick={() => setCategoriaAtiva(null)}
        >
          Todos
        </button>
        {categorias.map(cat => (
          <button
            key={cat.nome}
            className={`filtro-btn ${categoriaAtiva === cat.nome ? 'active' : ''}`}
            onClick={() => setCategoriaAtiva(cat.nome === categoriaAtiva ? null : cat.nome)}
          >
            {cat.emoji} {cat.nome}
          </button>
        ))}
      </div>

      {/* Produtos */}
      <div className="cardapio-content">
        {categoriasFiltradas.map(cat => (
          <div key={cat.nome} className="cardapio-categoria">
            <h2>{cat.emoji} {cat.nome}</h2>
            <div className="produtos-grid">
              {cat.produtos.map(prod => (
                <div key={prod.id} className={`produto-card${prod.sem_estoque ? ' produto-esgotado' : ''}`}>
                  <div className="produto-emoji">{prod.emoji || '🥟'}</div>
                  <div className="produto-info">
                    <h3>{prod.nome}</h3>
                    {prod.descricao && <p className="produto-desc">{prod.descricao}</p>}
                    {prod.tags && <span className="produto-tags">{prod.tags}</span>}
                  </div>
                  <div className="produto-preco">{formatCurrency(prod.preco)}</div>
                  {prod.destaque === 1 && !prod.sem_estoque && <span className="produto-destaque">⭐ Destaque</span>}
                  {prod.sem_estoque && <span className="produto-esgotado-badge">Esgotado</span>}
                </div>
              ))}
            </div>
          </div>
        ))}
        {categoriasFiltradas.length === 0 && (
          <div className="cardapio-vazio">
            <p>Nenhum produto encontrado.</p>
          </div>
        )}
      </div>
    </div>
  );
}
